<template>
  <div id="cabecera-tecnologica">
    <v-sheet
      :height="heroHeight"
      color="#0a0a0a"
      tile
      style="overflow: hidden; position: relative;"
    >
      <div class="tech-overlay"></div>

      <v-img
        :key="image"
        :src="image"
        gradient="to bottom, rgba(10, 14, 25, .95), rgba(10, 14, 25, .80)"
        height="100%"
        class="align-center"
      >
        <v-container>
          <v-row justify="center">
            <v-col cols="11" sm="10" md="10" class="text-center white--text container-reveal">
              
              <div class="reveal-wrapper mb-2 mb-md-4">
                <h1
                  class="console-text font-weight-bold text-uppercase console-cursor tech-glow"
                  :class="{
                    'text-h4': $vuetify.breakpoint.xsOnly,
                    'text-h3': $vuetify.breakpoint.smOnly,
                    'text-h2': $vuetify.breakpoint.mdAndUp
                  }"
                >
                  {{ title }}
                </h1>
              </div>

              <div class="reveal-wrapper delay-1">
                <v-divider class="mx-auto mb-4 tech-divider"></v-divider>
              </div>

              <div 
                v-if="subtitle"
                class="reveal-wrapper delay-2"
              >
                <div 
                   class="console-text font-weight-light tech-glow subtitle-responsive"
                  :class="$vuetify.breakpoint.smAndUp ? 'text-h5' : 'text-body-1'"
                >
                  <span class="cyan--text text--accent-3 mr-1">></span> {{ subtitle }}
                </div>
              </div>
              
            </v-col>
          </v-row>
        </v-container>
      </v-img>
    </v-sheet>
  </div>
</template>

<script>
export default {
  data: () => ({
    titles: {
      inicio: { title: "BIENVENIDO ROOT", subtitle: "Registre su identidad digital en .NI" },
      quienessomos: { title: "SISTEMA NIC.NI", subtitle: "Centro de Información de Red" },
      historia: { title: "LOG DE HISTORIA", subtitle: "Evolución de la red nacional" },
      valores: { title: "PROTOCOLOS CENTRALES", subtitle: "Nuestros Valores" },
      corresponsales: { title: "CORRESPONSALES", subtitle: "Registradores de dominios" },
      buscardominio: { title: "CONSULTA WHOIS", subtitle: "Verificar disponibilidad de nodo" },
      informaciongeneral: { title: "INFO GENERAL", subtitle: "Documentación del sistema" },
      whois: { title: "HERRAMIENTA WHOIS", subtitle: "Base de datos de red" },
      contactenos: { title: "CANAL DE CONTACTO", subtitle: "Soporte técnico directo" },
      faqs: { title: "BASE DE CONOCIMIENTO", subtitle: "Preguntas frecuentes" },
      pasosdominio: { title: "GUÍA DE ACTIVACIÓN", subtitle: "Protocolo de registro" },
      requisitos: { title: "REQUISITOS", subtitle: "Validación de parámetros" },
    },
  }),
  computed: {
    namespace() {
      if (!this.$route || !this.$route.name) return "inicio";
      return this.$route.name.toLowerCase();
    },
    image() {
      return "/static/" + this.namespace + "-team.jpg";
    },
    currentData() {
        return this.titles[this.namespace] || { title: 'NIC.NI', subtitle: 'Centro de Red' };
    },
    title() { return this.currentData.title; },
    subtitle() { return this.currentData.subtitle; },
    
    // Alturas dinámicas optimizadas para móvil
    heroHeight() {
      const isHome = this.namespace === 'inicio';
      if (this.$vuetify.breakpoint.xsOnly) return isHome ? '400px' : '250px';
      if (this.$vuetify.breakpoint.smOnly) return isHome ? '500px' : '300px';
      return isHome ? '75vh' : '400px';
    }
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Fira+Code:wght@300;700&display=swap');

.console-text {
  font-family: 'Fira Code', monospace !important;
  /* Reducimos el espaciado en móvil para que títulos largos no se corten */
  letter-spacing: -1px !important;
}

@media (max-width: 600px) {
  .console-text {
    letter-spacing: -2px !important;
    line-height: 1.2 !important;
  }
}

.tech-glow {
  text-shadow: 0 0 10px rgba(0, 229, 255, 0.4);
}

.console-cursor::after {
  content: '_';
  display: inline-block;
  margin-left: 5px;
  animation: blink-cursor 1s step-end infinite;
  color: #00e5ff;
}

.tech-divider {
  max-width: 80px;
  border-width: 2px;
  border-color: #00e5ff !important;
  box-shadow: 0 0 10px rgba(0, 229, 255, 0.5);
}

.tech-overlay {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background: repeating-linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.1) 0px,
    rgba(0, 0, 0, 0.1) 1px,
    transparent 1px,
    transparent 3px
  );
  pointer-events: none;
  z-index: 2;
}

/* --- Animaciones --- */
.reveal-wrapper {
  overflow: hidden;
}

.container-reveal .reveal-wrapper > * {
  animation: slideUpTech 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) both;
  transform: translateY(110%);
  opacity: 0;
}

.delay-1 > * { animation-delay: 0.3s; }
.delay-2 > * { animation-delay: 0.5s; }

@keyframes slideUpTech {
  from { transform: translateY(110%); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

@keyframes blink-cursor {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}

/* Ajuste fino para el subtítulo en móvil */
.subtitle-responsive {
  word-break: break-word;
  max-width: 90%;
  margin: 0 auto;
}
</style>